import { motion, AnimatePresence } from "framer-motion";
import { useSwipeable } from "react-swipeable";
import { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Cookies from "js-cookie";
import Rating from "@mui/material/Rating";
import Linkify from "react-linkify";
import { GalleryContext } from "../../../../App";
import ShareModal from "./ShareModal";
import ContactModal from "./ContactModal";
import CommentModal from "./CommentModal";
import ReportModal from "./ReportModal";
import OrgChartWithAPI from "../../properties/components/display/OrgChart";

export default function ModalDetail({
  dataMainModal,
  id,
  heightStep,
  setHeightStep,
  statusComponent,
}) {
  const checkLogin = () => {
    const session_id = Cookies.get("jwt");
    return session_id;
  };

  const { isGalleryOpen, setIsGalleryOpen } = useContext(GalleryContext);

  // Menu items including the "OrgChart" button
  const menuModalPreview = [
    {
      name: "ติดต่อผู้ขาย",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/16617/16617786.png",
      altText: "contact",
    },
    {
      name: "YouTube",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/174/174883.png",
      altText: "youtube",
    },
    {
      name: "VR/3D",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/10229/10229102.png",
      altText: "vr",
    },
    {
      name: "นำทาง",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/2335/2335353.png",
      altText: "maps",
    },
    {
      name: "ถูกใจ",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/5735/5735325.png",
      altText: "like",
    },
    {
      name: "แชร์ทรัพย์",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/3925/3925154.png",
      altText: "share",
    },
    {
      name: "รายงานทรัพย์",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/9019/9019234.png",
      altText: "report",
    },
    {
      name: "คอมเม้นท์",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/2190/2190552.png",
      altText: "comment",
    },
    {
      name: "ลำดับการแชร์",
      imgSrc: "https://cdn-icons-png.flaticon.com/512/3784/3784884.png",
      altText: "orgchart",
    },
  ];

  // State variables for modals and data
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [contactInfo, setContactInfo] = useState(null);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [assetRating, setAssetRating] = useState(null);
  const [assetCommentCounter, setAssetCommentCounter] = useState(null);

  // State variables for OrgChart
  const [orgChartData, setOrgChartData] = useState(null);
  const [isLoadingOrgChart, setIsLoadingOrgChart] = useState(false);
  const [orgChartError, setOrgChartError] = useState(null);

  // Fetch rating data
  const fetchRating = async (assetId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/event/rating?asset_id=${assetId}`
      );
      setAssetRating(response.data.summary_stars);
      setAssetCommentCounter(response.data.total_comments);
    } catch (error) {
      console.error("Failed to fetch rating", error);
      setAssetRating(null);
      setAssetCommentCounter(null);
    }
  };

  useEffect(() => {
    if (dataMainModal.id) {
      fetchRating(dataMainModal.id);
    }
  }, [dataMainModal.id]);

  // Handle comment submission
  const handleCommentSubmit = async (commentData) => {
    const { rating, comment } = commentData;
    const token = await checkLogin();

    if (token !== undefined) {
      axios
        .post(
          `${process.env.REACT_APP_API}/event/write-comment`,
          {
            asset_id: dataMainModal.id,
            rating: rating,
            content: comment,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          Swal.fire("Success", "Your comment has been submitted!", "success");
        })
        .catch((err) => {
          const errMessage =
            err.response?.data?.Error || "Something went wrong";
          Swal.fire("", errMessage, "warning");
        });
    } else {
      const result = await Swal.fire({
        title: "กรุณา Login",
        html: `<p style="text-align: left; font-size: 16px;">คุณต้องเข้าสู่ระบบก่อนจึงจะสามารถแสดงความคิดเห็นได้</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Login",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#007BFF",
        cancelButtonColor: "#6c757d",
        customClass: {
          popup: "swal-left-align",
        },
      });

      if (result.isConfirmed) {
        window.location.replace("/login");
      }
    }
  };

  // Handle contact info retrieval
  const handleContactInfo = async (assetId) => {
    const inviter = localStorage.getItem("@ID_INVITER");

    if (!inviter) {
      const currentUrl = new URL(window.location.href);
      const sharerParam = currentUrl.searchParams.get("sharer");

      if (sharerParam) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API}/event/convert-uname-uid`,
            { target_uid: sharerParam },
            {
              headers: {
                Authorization: `Bearer ${checkLogin()}`,
                Accept: "application/json, text/plain, */*",
                "Accept-Language": "en-US,en;q=0.9",
              },
            }
          );

          const targetUname = response.data.target_uname;

          if (targetUname) {
            localStorage.setItem("@ID_INVITER", targetUname);
          }
        } catch (error) {
          console.error("Error converting uname to uid:", error);
        }
      }
    }

    const currentUrl = new URL(window.location.href);
    const sharerParam = currentUrl.searchParams.get("sharer");

    const payload = { assetId: assetId };
    if (sharerParam) {
      payload.sharer = sharerParam;
    }

    axios
      .post(`${process.env.REACT_APP_API}/event/getContact`, payload, {
        headers: {
          Authorization: `Bearer ${checkLogin()}`,
        },
      })
      .then((res) => {
        setContactInfo(res.data);
        setIsContactModalOpen(true);
      })
      .catch((err) => {
        const errMessage = err.response.data.Error;
        if (checkLogin() === undefined) {
          window.open("/login?redirectBack=true", "_blank");
        }
      });
  };

  // Handle asset sharing
  const handleShareAsset = (assetId) => {
    axios
      .post(
        `${process.env.REACT_APP_API}/mlm/share?aid=${assetId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${checkLogin()}`,
          },
        }
      )
      .then((res) => {
        setShareUrl(res.data.shareurl);
        setIsShareModalOpen(true);
      })
      .catch((err) => {
        const errMessage = err.response.data.Error;
        if (checkLogin() === undefined) {
          window.open("/login?redirectBack=true", "_blank");
        }
      });
  };

  // Fetch OrgChart data
  const fetchOrgChartData = async () => {
    setIsLoadingOrgChart(true);
    setOrgChartError(null);
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API}/mlm/shareLogRealEstate`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          IdRealEstate: dataMainModal.id,
        },
      });
      if (response.data.success) {
        setOrgChartData(response.data.data);
      } else {
        setOrgChartError("API returned success: false");
      }
    } catch (error) {
      console.error("Error fetching OrgChart data:", error.message);
      setOrgChartError(error.message);
    } finally {
      setIsLoadingOrgChart(false);
    }
  };

  // Handle modal interactions
  function handleModalInfo(text, isYoutube, isVR_url) {
    const lat = dataMainModal.location.coordinates.lat;
    const lng = dataMainModal.location.coordinates.lng;

    switch (text) {
      case "youtube":
        if (isYoutube !== "") {
          window.open(`${dataMainModal.media.YoutubeURL}`);
        }
        break;
      case "vr":
        if (isVR_url !== "") {
          window.open(`${dataMainModal.media.vr_url}`);
        }
        break;
      case "maps":
        window.open(`https://www.google.com/maps?q=${lat},${lng}`);
        break;
      case "like":
        const token = localStorage.getItem("token");
        if (token) {
          handleAddToCart(dataMainModal.id);
        } else {
          window.location.replace("/login");
        }
        break;
      case "contact":
        sessionStorage.setItem("isClickContactModalDetail", true);
        handleContactInfo(dataMainModal.id);
        break;
      case "comment":
        setIsCommentModalOpen(true);
        break;
      case "report":
        setIsReportModalOpen(true);
        break;
      case "share":
        handleShareAsset(dataMainModal.id);
        break;
      case "orgchart":
        fetchOrgChartData();
        break;
      default:
        break;
    }
  }

  // Add asset to cart
  const handleAddToCart = (assetId) => {
    axios
      .post(
        `${process.env.REACT_APP_API}/event/addBasket?assetId=${assetId}`,
        {
          assetId: assetId,
        },
        {
          headers: {
            Authorization: `Bearer ${checkLogin()}`,
          },
        }
      )
      .then((res) => {
        const msg = res.data.message;
        Swal.fire("สำเร็จ", `${msg}`, "success");
      })
      .catch((err) => {
        const errMessage = err.response.data.Error;
        Swal.fire("", `${errMessage}`, "warning");
        if (checkLogin() === undefined) {
          window.location.replace("/login");
        }
      });
  };

  // Additional state variables
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const heightMap = {
    hide: "0px",
    min: "12vh",
    half: "60vh",
    full: "92vh",
  };

  const openModal = (image, index) => {
    setIsGalleryOpen(true);
    const isDesktop = window.innerWidth > 768;
    if (isDesktop) {
      // nothing
    } else {
      setSelectedImage(image);
      setIsModalOpen(true);
    }
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
  };

  const formatPrice = (price) => {
    if (price >= 1000000) {
      return `${(price / 1000000).toFixed(2)} ล้านบาท`;
    } else {
      return `${price.toLocaleString()} บาท`;
    }
  };

  const [isDraggingFromScrollArea, setIsDraggingFromScrollArea] = useState(false);

  const handleDragEnd = (e, info) => {
    if (isDraggingFromScrollArea) {
      setIsDraggingFromScrollArea(false);
      return;
    }
    const currentUrl = new URL(window.location.href);
    const verticalThreshold = 5;
    const verticalMovement = Math.abs(info.offset.y);

    if (verticalMovement > verticalThreshold) {
      let positionY = info.point.y;
      const windowHeight = window.innerHeight;

      if (positionY < windowHeight / 4) {
        setHeightStep("full");
        currentUrl.searchParams.set("card", "full");
      } else if (positionY < windowHeight * 0.65) {
        setHeightStep("half");
        currentUrl.searchParams.set("card", "half");
      } else {
        setHeightStep("min");
        currentUrl.searchParams.set("card", "min");
      }
      window.history.pushState({}, "", currentUrl);
    }
  };

  const swipeCardHandler = useSwipeable({
    onSwipedUp: () => setHeightStep("full"),
    onSwipedDown: () => setHeightStep("min"),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const goToPreviousImage = () => {
    const newIndex =
      (currentImageIndex - 1 + dataMainModal.images_url.AssetImagesURL.length) %
      dataMainModal.images_url.AssetImagesURL.length;
    setCurrentImageIndex(newIndex);
  };

  const [divHeight, setDivHeight] = useState("300px");

  useEffect(() => {
    const textLength = dataMainModal.description.length;
    let calculatedHeight;

    if (textLength > 300) {
      calculatedHeight = "520px";
    } else if (textLength < 100) {
      calculatedHeight = "100px";
    } else {
      calculatedHeight = `${300 + (textLength - 500) * (500 / 300)}px`;
    }
    setDivHeight(calculatedHeight);
  }, [dataMainModal.description]);

  const fadeTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 1.2 },
  };

  const goToNextImage = () => {
    const newIndex =
      (currentImageIndex + 1) % dataMainModal.images_url.AssetImagesURL.length;
    setCurrentImageIndex(newIndex);
  };

  const totalImages = dataMainModal.images_url.AssetImagesURL.length;
  const [swipeDirection, setSwipeDirection] = useState(null);

  const gallerySwipeHandler = useSwipeable({
    onSwipedLeft: () => {
      setSwipeDirection("left");
      goToNextImage();
    },
    onSwipedRight: () => {
      setSwipeDirection("right");
      goToPreviousImage();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const fadeInImagesTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: {
      duration: 1.5,
      delay: 0.3,
    },
  };

  return (
    <>
      <motion.main
        className={`z-40 w-full bg-white rounded-t-3xl shadow-2xl overflow-hidden bottom-0 left-0 right-0 ${
          statusComponent === "map" ? "absolute" : "fixed"
        }`}
        initial={{ height: 0 }}
        animate={{ height: heightMap[heightStep] }}
        transition={{ duration: 0.4, ease: [0.32, 0.72, 0, 1] }}
      >
        {/* Sub-modals */}
        <CommentModal
          isOpen={isCommentModalOpen}
          onRequestClose={() => setIsCommentModalOpen(false)}
          onSubmit={handleCommentSubmit}
          assetId={dataMainModal.id}
        />
        <ShareModal
          isOpen={isShareModalOpen}
          onRequestClose={() => setIsShareModalOpen(false)}
          shareUrl={shareUrl}
        />
        <ReportModal
          isOpen={isReportModalOpen}
          onRequestClose={() => setIsReportModalOpen(false)}
          assetId={dataMainModal.id}
        />
        <ContactModal
          isOpen={isContactModalOpen}
          onRequestClose={() => setIsContactModalOpen(false)}
          contactInfo={contactInfo}
        />

        {/* Edit button for lead assets */}
        {dataMainModal.imperfect_asset && dataMainModal.data.editable && (
          <motion.button
            className="absolute top-16 right-4 z-50 bg-blue-600 text-white text-sm px-4 py-1.5 rounded-full shadow-lg hover:bg-blue-700"
            onClick={() => { window.location.href = `/edit/lead/${dataMainModal.id}`; }}
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          >
            แก้ไขประกาศ
          </motion.button>
        )}

        {/* ── Drag handle + height controls ── */}
        <div className={`flex justify-center items-center pt-3 pb-2 gap-2 ${dataMainModal.sold ? "bg-gradient-to-r from-red-500 to-red-400" : dataMainModal.official ? "bg-gradient-to-r from-yellow-500 to-amber-400" : "bg-gradient-to-r from-blue-500 to-indigo-500"}`}>
          {heightStep === "min" && (
            <button
              onClick={() => { setHeightStep("half"); const u = new URL(window.location.href); u.searchParams.set("card","half"); window.history.pushState({},"",u); }}
              className="w-8 h-8 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center text-xs font-bold"
            >▲</button>
          )}
          {heightStep === "half" && (
            <>
              <button
                onClick={() => { setHeightStep("full"); const u = new URL(window.location.href); u.searchParams.set("card","full"); window.history.pushState({},"",u); }}
                className="w-8 h-8 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center text-xs font-bold"
              >▲</button>
              <div className="w-10 h-1 bg-white/60 rounded-full" />
              <button
                onClick={() => { setHeightStep("min"); const u = new URL(window.location.href); u.searchParams.set("card","min"); window.history.pushState({},"",u); }}
                className="w-8 h-8 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center text-xs font-bold"
              >▼</button>
            </>
          )}
          {heightStep === "full" && (
            <>
              <div className="w-10 h-1 bg-white/60 rounded-full" />
              <button
                onClick={() => { setHeightStep("half"); const u = new URL(window.location.href); u.searchParams.set("card","half"); window.history.pushState({},"",u); }}
                className="w-8 h-8 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center text-xs font-bold"
              >▼</button>
            </>
          )}
        </div>

        <div className="flex flex-col w-full h-full">

          {/* ── HEADER ── */}
          <div className={`px-4 pt-2 pb-3 border-b border-gray-100 ${dataMainModal.sold ? "bg-red-50" : ""}`}>
            {/* Top row: type badges + share */}
            <div className="flex items-center justify-between mb-2">
              <div className="flex gap-1.5 flex-wrap">
                {dataMainModal.type_post && dataMainModal.type_post.Type.length > 0 &&
                  dataMainModal.type_post.Type.map((type, i) => (
                    <span key={i} className="text-xs bg-blue-500 text-white px-2.5 py-0.5 rounded-full font-semibold">
                      {type}
                    </span>
                  ))
                }
              </div>
              <button
                onClick={() => handleShareAsset(dataMainModal.id)}
                className="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full text-white shadow-sm flex-shrink-0"
                style={dataMainModal.official ? { backgroundColor: '#BF932A' } : { backgroundColor: '#3b82f6' }}
              >
                <img src="https://cdn-icons-png.flaticon.com/512/3925/3925154.png" className="w-3.5 h-3.5" alt="" />
                แชร์ทรัพย์
              </button>
            </div>

            {/* Title + ID */}
            <h1 className={`text-base font-bold leading-snug ${dataMainModal.sold ? "text-red-600" : "text-gray-900"}`}>
              {dataMainModal.sold ? "ทรัพย์นี้ได้ขายออกไปแล้ว" : dataMainModal.title.slice(0, 43)}
            </h1>
            <p className="text-xs text-gray-400 mt-0.5">{dataMainModal.id}</p>

            {/* Price */}
            {!dataMainModal.sold && (
              <p className="text-xl font-bold text-emerald-600 mt-1">
                {dataMainModal.sell_price
                  ? formatPrice(dataMainModal.sell_price)
                  : dataMainModal.rent_price
                  ? formatPrice(dataMainModal.rent_price)
                  : dataMainModal.sellout_price
                  ? formatPrice(dataMainModal.sellout_price)
                  : "ราคาติดต่อผู้ขาย"}
              </p>
            )}

            {/* Rating */}
            {assetRating !== null && assetCommentCounter !== null && (
              <div className="flex items-center gap-2 mt-1.5">
                {dataMainModal.allowcomment ? (
                  <>
                    <Rating name="read-only" value={assetRating} readOnly size="small" />
                    <span className="text-xs text-gray-500">{assetRating} ดาว</span>
                    <button className="text-xs text-blue-500 underline ml-auto" onClick={() => setIsCommentModalOpen(true)}>
                      ({assetCommentCounter}) คอมเม้นท์
                    </button>
                  </>
                ) : (
                  <span className="text-xs text-gray-400">ปิดความคิดเห็น</span>
                )}
              </div>
            )}
          </div>

          {/* ── ACTION MENU ── */}
          <div className="w-full h-auto">
          <div className="flex overflow-x-auto  px-2 h-16  h-22">
            {menuModalPreview.map((data, index) => {
              const youtube = dataMainModal.media.YoutubeURL;
              const vr_url = dataMainModal.media.vr_url;
              const isYouTubeDisabled = youtube === "" && data.name === "YouTube";
              const isVRDisabled = vr_url === "" && data.name === "VR/3D";
              if (data.name === "แชร์ทรัพย์") return null;
              return (
                <button
                  key={index}
                  onClick={() => !isYouTubeDisabled && !isVRDisabled && handleModalInfo(data.altText, youtube, vr_url)}
                  className={`flex flex-col items-center gap-1.5 flex-shrink-0 px-3 py-3 transition-colors ${
                    isYouTubeDisabled || isVRDisabled
                      ? "opacity-35 cursor-not-allowed"
                      : "hover:bg-gray-50 cursor-pointer"
                  }`}
                >
                  <img className="w-7 h-7" src={data.imgSrc} alt={data.altText} />
                  <span className="text-[10px] text-gray-600 whitespace-nowrap">{data.name}</span>
                </button>
              );
            })}
          </div>
          </div>

          {/* ── IMAGES ── */}
          <motion.div
            className="flex gap-2 px-3 py-2 overflow-x-auto flex-shrink-0"
            style={{
              height: heightStep === "full"
                ? dataMainModal.images_url.AssetImagesURL.length === 1 ? "44vh" : "27vh"
                : heightStep === "half"
                ? "140px"
                : "100px",
            }}
            key={heightStep}
            initial={fadeInImagesTransition.initial}
            animate={fadeInImagesTransition.animate}
            transition={fadeInImagesTransition.transition}
          >
            {dataMainModal.images_url.AssetImagesURL.map((image, index) => (
              <img
                key={index}
                className={`cursor-pointer rounded-xl object-cover shadow-sm flex-shrink-0 ${
                  heightStep === "full"
                    ? "h-full w-full"
                    : "h-full w-auto"
                }`}
                src={image}
                alt={`Image ${index + 1}`}
                onClick={() => openModal(image, index)}
              />
            ))}
          </motion.div>

          {/* ── DESCRIPTION ── */}
          <div
            className="overflow-y-auto px-4 py-3 text-sm text-gray-700 leading-relaxed whitespace-pre-wrap"
            style={{ height: divHeight }}
            onWheel={(e) => e.stopPropagation()}
            onTouchStart={(e) => { e.stopPropagation(); setIsDraggingFromScrollArea(true); }}
            onTouchMove={(e) => e.stopPropagation()}
            onMouseDown={(e) => { e.stopPropagation(); setIsDraggingFromScrollArea(true); }}
            onDragStart={(e) => { e.stopPropagation(); setIsDraggingFromScrollArea(true); }}
            onDrag={(e) => e.stopPropagation()}
          >
            <Linkify
              componentDecorator={(href, text, key) => (
                <a href={href} key={key} style={{ color: "#1e90ff", textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">
                  {text}
                </a>
              )}
            >
              {dataMainModal.description}
            </Linkify>
          </div>

          {/* ── ORGCHART ── */}
          {isLoadingOrgChart && (
            <div className="flex justify-center items-center h-20 gap-3">
              <div className="animate-spin rounded-full h-6 w-6 border-2 border-blue-500 border-t-transparent" />
              <p className="text-sm text-gray-600">กำลังโหลด OrgChart...</p>
            </div>
          )}
          {orgChartError && (
            <div className="mx-4 mt-2 bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-xl">
              <strong>เกิดข้อผิดพลาด:</strong> {orgChartError}
            </div>
          )}
          {orgChartData && (
            <div className="mt-2">
              <OrgChartWithAPI
                apiData={orgChartData}
                setOrgChartData={setOrgChartData}
                loading={isLoadingOrgChart}
                error={orgChartError}
                onRefresh={fetchOrgChartData}
              />
            </div>
          )}
        </div>
      </motion.main>

      {isGalleryOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
          <div
            {...gallerySwipeHandler}
            className="relative flex flex-col justify-center items-center w-full h-full"
          >
            <button
              className="absolute left-0 ml-4 text-white bg-white rounded-full px-4 py-2 z-10"
              onClick={() => {
                setSwipeDirection("right");
                goToPreviousImage();
              }}
            >
              <img src="https://cdn-icons-png.flaticon.com/512/2989/2989988.png" className="w-8 h-8 rotate-180"/>
            </button>
            <AnimatePresence initial={false}>
              <motion.div
                key={currentImageIndex}
                className="absolute"
                initial={{
                  opacity: 0,
                  x: swipeDirection === "left" ? 100 : -100,
                }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: swipeDirection === "left" ? -100 : 100 }}
                transition={{ duration: 0.8 }}
              >
                <img
                  src={
                    dataMainModal.images_url.AssetImagesURL[currentImageIndex]
                  }
                  alt={`Image ${currentImageIndex + 1}`}
                  className="max-w-full max-h-full"
                />
                <div className="absolute text-white flex justify-center items-center w-full">
                  ภาพที่ {currentImageIndex + 1} จาก {totalImages}
                </div>
              </motion.div>
            </AnimatePresence>
            <div className="absolute bottom-20 flex space-x-2 w-full justify-center">
              {dataMainModal.images_url.AssetImagesURL.map((_, index) => (
                <div
                  key={index}
                  className={`w-2 h-2 rounded-full ${
                    index === currentImageIndex ? "bg-white" : "bg-gray-600"
                  }`}
                ></div>
              ))}
            </div>

            <button
              className="absolute right-0 mr-4 text-white bg-white rounded-full px-4 py-2 z-10"
              onClick={() => {
                setSwipeDirection("left");
                goToNextImage();
              }}
            >
              <img src="https://cdn-icons-png.flaticon.com/512/2989/2989988.png" className="w-8 h-8 "/>
            </button>
            <button
              className="absolute top-5 right-5 text-white bg-red-500 hover:bg-red-700 rounded-full px-4 py-2 z-10"
              onClick={closeGallery}
            >
              ปิดเมนู
            </button>
          </div>
        </div>
      )}
    </>
  );
}